import businessClient from 'src/services/clients/business'
import { IMeta } from 'src/common/interfaces/index.js'
import { formDataGenerator } from 'src/common/helpers/generator/formdata.helper'

const IAssetResponse = { meta: IMeta, data: {} }

export const asset = {
  /**
   * @param {{data: Record<string, any>; entity_id: string | number; entity_type: string; sort?: number[] }} payload
   * @return {Promise<IAssetResponse>}
   */
  upload(payload, signal = undefined) {
    const formData = formDataGenerator(payload)

    // formData.forEach((value, key) => {
    //   console.log({ key, value })
    // })

    return businessClient().post('asset/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'upload-type': 'image' },
      signal,
    })
  },

  /**
   * @param {{data: Record<string, any>; entity_id: string | number; entity_type: string; sort?: number[] }} payload
   * @return {Promise<IAssetResponse>}
   */
  uploadVideo(payload, signal) {
    const formData = formDataGenerator(payload)

    return businessClient().post('asset/upload/video', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'upload-type': 'video' },
      signal,
    })
  },
}
